// src/features/participants/page/PolicyForm.tsx

import dayjs from 'dayjs';
import { API_ENDPOINTS, QUERY_KEYS } from '../../api/apiEndpoints';
import DynamicForm, { type DynamicFormSchema } from '@/common/components/DynamicForm/DynamicForm';
import { useTranslation } from 'react-i18next';
export default function PolicyForm() {

    const inceptionDate = dayjs();
    const expiryDate = inceptionDate.add(1, 'year').subtract(1, 'day');
 const { t } = useTranslation();

const policyFormSchema: DynamicFormSchema = {
  layout: 'vertical', // Overall form layout
 // submitButtonText: 'Save User', // Custom text for the submit button
    showResetButton: true, // Show a reset button
    
  // Define form sections for better organization and complex layouts
    sections: [
        {
            key: 'policy-details',
            title: 'Policy Details',
            type: 'card',
            layout: { type: 'grid', gutter: 24 },
            fields: [
                {
                    name: 'policyHolderPrefix',
                    label: 'Policy Holder Type',
                    type: 'select',
                    required: true,
                    // disableOnEdit: true,
                    disabled: true,
                    hidden: true,
                    defaultValue: 'CM',
                    requiredMessage: 'Policy Holder Type is required.',
                    colSpan: 0, // Full width
                    placeholder: "Select policy holder type",
                    showSearch: true, // Enable search functionality
                    options: [
                        { label: 'Individual', value: 'IN' },
                        { label: 'Company', value: 'CM' },
                    ],
                },
                {
                    name: 'customerId',
                    label: 'Customer',
                    type: 'select',
                    colSpan: 12, // Full width
                    disableOnEdit: true,
                    required: true,
                    requiredMessage: 'Please select a customer.', // Custom required message
                    placeholder: "Select customer",
                    options: [], // Keep this empty as options will be dynamic
                    dynamicOptions: { // Configuration for fetching options from an API
                        url: "/Lookup/GetDropdownData", // Your API endpoint for skills (ensure it returns an array of objects like {id: 1, name: "JavaScript"})
                        method: "POST", // HTTP method for the request
                        body: { "dropdowns": ["customer"] },
                        // JavaScript function string to transform the API response into { label, value } format
                        transformData: "(apiResponse) => apiResponse.customer.map(item => ({ label: item.Name, value: item.Id }))"
                    }
                },
                {
                    name: 'policyHolderName',
                    label: 'Policy Holder',
                    disabled: true,
                    disableOnEdit: true,
                    type: 'input',
                    hideOnAdd: true,
                    colSpan: 12,
                },
                {
                    name: 'policyHolderId',
                    label: 'Policy Holder',
                    type: 'select',
                    disableOnEdit: true,
                    required: true,
                    requiredMessage: 'Policy Holder is required.',
                    showSearch: true, // Enable search functionality
                    hideOnEdit: true,
                    colSpan: 12,
                    options: [],
                    dynamicOptions: {
                        url: "/Policy/GetPolicyHolderDropdown",
                        method: 'GET',
                        transformData: "(apiResponse) => apiResponse.map(item => ({ label: item.name, value: item.id }))",
                        dependsOn: ['policyHolderPrefix', 'customerId'],
                        onEmpty: {
                            message: t('policyHolderId.onEmpty'),
                            type: 'error',
                        },
                    },
                    disabledWhen: [
                        {
                            field: 'policyHolderPrefix',
                            operator: 'isFalsy',
                        },
                    ],
                },
                //{
                //    name: 'nationalIDNo',
                //    label: 'National ID Number',
                //    type: 'input',
                //    dependencies: [
                //       { "field": "policyHolderPrefix", "operator": "===", "value": "IN" }
                //    ],
                //    colSpan: 12,
                //},
                {
                    name: 'category',
                    label: 'Category',
                    type: 'select',
                    options: [
                        { label: 'A', value: 'A' },
                        { label: 'B', value: 'B' },
                        { label: 'C', value: 'C' },
                    ],
                    colSpan: 12,
                    required: [{ "field": "policyHolderPrefix", "operator": "===", "value": "IN" }],
                    dependencies: [
                        { field: 'policyHolderPrefix', operator: '===', value: 'IN' }
                    ],
                },
            ],
        },
        {
            key: 'policy-dates',
            title: 'Policy Period',
            type: 'card',
            layout: { type: 'grid', gutter: 24 },
            fields: [
                {
                    name: 'inceptionDate',
                    label: 'Inception Date',
                    type: 'date',
                    required: true,
                    colSpan: 12,
                    defaultValue: inceptionDate,
                },
                {
                    name: 'expiryDate',
                    label: 'Expiry Date',
                    type: 'date',
                    defaultValue: expiryDate,
                    required: true,
                    colSpan: 12,
                    disabledWhen: [
                        {
                            field: 'inceptionDate',
                            operator: 'isFalsy',
                        },
                    ],
                    disabledDateFunction: "(current) => { const inceptionDate = form.getFieldValue('inceptionDate'); if (!inceptionDate) { return false; } return current && current < inceptionDate.startOf('day'); }"
                }
            ],
        },
        
        {
            key: 'policy-plan-info',
            title: 'Plan Information',
            type: 'card',
            layout: { type: 'grid', gutter: 24 },
            fields: [
                //{
                //    name: 'planGroupId',
                //    label: 'Plan Group',
                //    type: 'select',
                //    colSpan: 12, // Full width
                //    placeholder: "Select plan group",
                //    required: true,
                //    requiredMessage: 'Plan Group is required.',
                //    showSearch: true, // Enable search functionality
                //    options: [], // Keep this empty as options will be dynamic
                //    dynamicOptions: { // Configuration for fetching options from an API
                //        url: "/Lookup/GetDropdownData", // Your API endpoint for skills (ensure it returns an array of objects like {id: 1, name: "JavaScript"})
                //        method: "POST", // HTTP method for the request
                //        body: { "dropdowns": ["plangroup"] },
                //        // JavaScript function string to transform the API response into { label, value } format
                //        transformData: "(apiResponse) => apiResponse.plangroup.map(item => ({ label: item.Name, value: item.Id }))"
                //    },
                //},
                {
                    name: 'planId',
                    label: 'Plan',
                    type: 'select',
                    required: true,
                    requiredMessage: 'Select plan',
                    showSearch: true, // Enable search functionality
                    colSpan: 12,
                    options: [],
                    dynamicOptions: {
                        url: "/Plan/GetPlanByCompanyIdDropdown",
                        method: 'GET',
                        transformData: "(apiResponse) => apiResponse.map(item => ({ label: item.name, value: item.id, ISOCode: item.currencyISOCode }))",
                        dependsOn: ['policyHolderId', 'policyHolderPrefix', 'customerId'],
                    },
                    disabledWhen: [
                        {
                            field: 'policyHolderId',
                            operator: 'isFalsy',
                        },
                    ],
                },
            ],
        },
        {
            key: 'policy-notes',
            title: 'Notes',
            type: 'card',
            layout: { type: 'grid', gutter: 24 },
            fields: [
                {
                    name: 'note',
                    label: 'Note',
                    type: 'textarea',
                    colSpan: 24,
                    validation: [
                        { max: 500, message: 'Note cannot be more than 500 characters long.' },
                    ],
                },
            ],
        },
        {
            key: 'policy-sales',
            title: 'Sales',
            type: 'card',
            layout: { type: 'grid', gutter: 24 },
            fields: [
                {
                    name: 'salesPersonId',
                    label: 'Sales Person',
                    type: 'select',
                    colSpan: 12, // Full width
                    placeholder: "Select sales person",
                    showSearch: true, // Enable search functionality
                    options: [], // Keep this empty as options will be dynamic
                    dynamicOptions: { // Configuration for fetching options from an API
                        url: "/Lookup/GetDropdownData", // Your API endpoint for skills (ensure it returns an array of objects like {id: 1, name: "JavaScript"})
                        method: "POST", // HTTP method for the request
                        body: { "dropdowns": ["salesperson"] },
                        // JavaScript function string to transform the API response into { label, value } format
                        transformData: "(apiResponse) => apiResponse.salesperson.map(item => ({ label: item.Name, value: item.Id }))"
                    },
                },
            ],
        },
    ]

};

  return (
    <DynamicForm
          schema={policyFormSchema}
          submitApiUrl={API_ENDPOINTS.POLICIES.SAVE_POLICY}
          getByIdApiUrl={API_ENDPOINTS.POLICIES.GET_POLICY_BY_ID}
          updateApiUrl={API_ENDPOINTS.POLICIES.UPDATE_POLICY}
          refreshTableDataKey={QUERY_KEYS.POLICIES.Policy} 
    />
  );
}
